import {Injectable, NgZone} from "@angular/core";
import posthog from "posthog-js";
import {environment} from "../../environments/environment";
import {UserProfile} from "../shared/types/UserProfile";
import {StateService} from './state.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';

@Injectable({providedIn: "root"})
export class PosthogService {
  constructor(private ngZone: NgZone, private stateService: StateService, private router: Router) {
    this.initPostHog();
    this.trackPageViews();
  }

  private initPostHog(): void {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2025-05-24',
        capture_pageview: false,
      });
    });
  }

  private trackPageViews(): void {
    this.ngZone.runOutsideAngular(() => {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          posthog.capture("$pageview", {
            $current_url: window.location.href,
            $pathname: event.urlAfterRedirects,
            viewed_account: this.stateService.activeAccount(),
          });
        });
    });
  }

  public identify(user: UserProfile): void {
    this.ngZone.runOutsideAngular(() => {
      posthog.identify(user.id, {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        role: user.role || "NA",
        account: user.account || "NA",
      });
    });
  }

  public reset(): void {
    this.ngZone.runOutsideAngular(() => {
      posthog.reset();
    });
  }

  public capture(eventName: string, properties: Record<string, any> = {}): void {
    this.ngZone.runOutsideAngular(() => {
      posthog.capture(eventName, properties);
    });
  }

}
